export default {"src":"/_next/static/media/DHR.b7cf1ee0.svg","height":18,"width":18};